<template>
    <div v-if="display">
        <!--<h1>{{ getTranslation('app_lbl_headline_home') }}</h1>-->
        <ul class="nav nav-tabs">
            <li :class="{ active: isTabActive['tab1'] }">
                <a href="#" @click.prevent="setActiveTab('tab1')">
                    {{ getTranslation('lbl_tab_dashboard') }}
                </a>
            </li>
            <li :class="{ active: isTabActive['tab2'] }">
                <a href="#" @click.prevent="setActiveTab('tab2')">
                    {{ getTranslation('lbl_tab_management') }}
                </a>
            </li>
            <li v-show='can("god4all.admin.user.client")' :class="{ active: isTabActive['tab3'] }">
                <a href="#" @click.prevent="setActiveTab('tab3')">
                    {{ getTranslation('menu_main_user_list') }}
                </a>
            </li>
            <li :class="{ active: isTabActive['tab4'] }" v-if="client.useCustomers">
                <a href="#" @click.prevent="setActiveTab('tab4')">
                    {{ getTranslation('menu_main_customer_list') }}
                </a>
            </li>
        </ul>
        <div class="row client-details-wrapper" v-if="isTabActive['tab3']">
            <user-list :client="client" hideTitle="true"></user-list>
        </div>
        <div class="row client-details-wrapper" v-if="isTabActive['tab2']">
            <call-settings :client="client"></call-settings>
        </div>
        <div class="row client-details-wrapper" v-if="isTabActive['tab2']">
            <div class="col-sm-6">
                <table class="table table-striped table-condensed">
                    <tr>
                        <th></th>
                        <td>
                            <div class="row">
                                <div class="col-sm-8">

                                </div>
                                <div class="col-sm-4 pull-right">
                                    <router-link :to="`/history/files`" activeClass="active" tag="button"
                                                     class="btn btn-primary"
                                                     :title="getTranslation('lbl_history_sounds')">
                                        <i class="fa fa-history" aria-hidden="true"></i>
                                    </router-link>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_hotlineNumber') }}</th>
                        <td>{{ client.hotlineNumber }}</td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_onDutyFile') }}</th>
                        <td>
                            <div v-if="client.onDutyFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.onDutyFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview0')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview0'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview0')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_onDutyFile" ref="audioPreview0"
                                           @ended="stopRecord('audioPreview0')"
                                           :src="filePath + 'getondutyfile'">
                                    </audio>
                                    <button @click="showConfirmDialog('onDutyFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_offDutyFile') }}</th>
                        <td>
                            <div v-if="client.offDutyFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.offDutyFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview1')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview1'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview1')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_offDutyFile" ref="audioPreview1"
                                           @ended="stopRecord('audioPreview1')"
                                           :src="filePath + 'getoffdutyfile'">
                                    </audio>
                                    <button @click="showConfirmDialog('offDutyFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_disturbFile') }}</th>
                        <td>
                            <div v-if="client.disturbFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.disturbFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview2')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview2'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview2')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_disturbFile" ref="audioPreview2"
                                           @ended="stopRecord('audioPreview2')"
                                           :src="filePath + 'disturb'">
                                    </audio>
                                    <button @click="showConfirmDialog('disturbFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_helpFile') }}</th>
                        <td>
                            <div v-if="client.helpFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.helpFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview3')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview3'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview3')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_helpFile" ref="audioPreview3"
                                           @ended="stopRecord('audioPreview3')"
                                           :src="filePath + 'helptext'">
                                    </audio>
                                    <button @click="showConfirmDialog('helpFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_acceptedFile') }}</th>
                        <td>
                            <div v-if="client.acceptedFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.acceptedFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview4')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview4'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview4')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_acceptedFile" ref="audioPreview4"
                                           @ended="stopRecord('audioPreview4')"
                                           :src="filePath + 'accepted'">
                                    </audio>
                                    <button @click="showConfirmDialog('acceptedFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_deniedFile') }}</th>
                        <td>
                            <div v-if="client.deniedFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.deniedFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview5')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview5'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview5')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_deniedFile" ref="audioPreview5"
                                           @ended="stopRecord('audioPreview5')"
                                           :src="filePath + 'denied'">
                                    </audio>
                                    <button @click="showConfirmDialog('deniedFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ getTranslation('lbl_client_invalidFile') }}</th>
                        <td>
                            <div v-if="client.invalidFile" class="row">
                                <div class="col-sm-8">
                                    {{ client.invalidFile }}
                                </div>
                                <div class="col-sm-4 pull-right">
                                    <button @click.prevent="playRecord('audioPreview6')" class="btn btn-default"
                                            :title="getTranslation(playStopTooltip('audioPreview6'))">
                                        <span class="fa"
                                              :class="audioPreviewClass('audioPreview6')"
                                              aria-hidden="true"></span>
                                    </button>
                                    <audio id="audio_invalidFile" ref="audioPreview6"
                                           @ended="stopRecord('audioPreview6')"
                                           :src="filePath + 'invalid'">
                                    </audio>
                                    <button @click="showConfirmDialog('invalidFile')"
                                            class="btn btn-danger"
                                            :title="getTranslation('lbl_delete')" >
                                        <span class="fa fa-trash" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="client.useCustomers">
                      <th>{{ getTranslation('lbl_client_inputCode') }}</th>
                      <td>
                        <div class="row">
                          <div class="col-sm-8">
                            {{ client.codeFile }}
                          </div>
                          <div class="col-sm-4 pull-right">
                            <button @click.prevent="playRecord('audioPreview7')" class="btn btn-default"
                                    :title="getTranslation(playStopTooltip('audioPreview7'))">
                                          <span class="fa"
                                                :class="audioPreviewClass('audioPreview7')"
                                                aria-hidden="true"></span>
                            </button>
                            <audio id="audio_enterCode" ref="audioPreview7"
                                   @ended="stopRecord('audioPreview7')"
                                   :src="filePath + 'code'">
                            </audio>
                            <button @click="showConfirmDialog('codeFile')"
                                    class="btn btn-danger"
                                    :title="getTranslation('lbl_delete')" >
                              <span class="fa fa-trash" aria-hidden="true"></span>
                            </button>
                          </div>
                        </div>
                      </td>
                  </tr>
                </table>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>{{ getTranslation('lbl_upload_files') }}</label>
                    <banet-upload :autoUpload="false" ref="fileUpload" @setFiles="setFiles" @tempFiles="setTempFiles"></banet-upload>
                </div>
            </div>
        </div>
        <div class="row" v-if="isTabActive['tab1']">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <timeplan-block v-if="timeplanDisplay" :client="client"></timeplan-block>
                </div>
            </div>
        </div>
        <div class="row" v-if="isTabActive['tab1']">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <contacts-block v-if="contactsDisplay" :client="client"></contacts-block>
                </div>
            </div>
        </div>
        <div class="row" v-if="isTabActive['tab1']">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <tickets-block v-if="ticketsDisplay" :client="client"></tickets-block>
                </div>
            </div>
        </div>
        <template v-if="isTabActive['tab4']">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <customer-block v-if="customerDisplay" :client="client"></customer-block>
                </div>
            </div>
        </template>

        <!-- Button trigger modal -->
        <banet-modal-confirm
                @confirmNo="unconfirm"
                @confirmYes="confirm"
                :show="showConfirm"
                :showFooter="true"
                :title="getTranslation('modalTitle')"
                :body="getTranslation('someText')">
        </banet-modal-confirm>
        <banet-modal-confirm
                @confirmNo="confirmDelete(false)"
                @confirmYes="confirmDelete(true)"
                :show="showConfirmDelete"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_client_file_delete')">
        </banet-modal-confirm>
        <banet-modal-info
                @infoClose="closeModalInfo"
                :show="show"
                :showFooter="true"
                :title="' '"
                :body="'Your answer is ' + answer">
        </banet-modal-info>
    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { alertMixin } from '../../../../Banet/mixins/alertMixin.js';
    import { userMixin } from '../../../../Banet/mixins/userMixin.js';
    import BanetModalInfo from '../../../../Banet/errorsAndNotifications/BanetModalInfo.vue';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    import Contacts from '../../../protected/components/contacts/Contacts.vue';
    import Tickets from '../../../protected/components/tickets/Tickets.vue';
    import Timeplan from '../../../protected/components/timeplan/Timeplan.vue';
    import Upload from '../../../protected/components/upload/Upload.vue';
    import UserList from '../../../protected/components/user/UserList.vue';
    import CustomerList from "../../../protected/components/customer/CustomerList.vue";
    import CallSettings from "../../../protected/components/settings/call_settings.vue";

    export default {
        components: {
            customerBlock: CustomerList,
            banetModalInfo: BanetModalInfo,
            banetModalConfirm: BanetModalConfirm,
            contactsBlock: Contacts,
            ticketsBlock: Tickets,
            timeplanBlock: Timeplan,
            banetUpload: Upload,
            userList: UserList,
            callSettings: CallSettings,
        },
        sockets:{
            triesUpdated: function(){
                this.$socket.emit('getClientPerUser');
            },
            clientData: function(client){
                this.display = client ? true : false;
                this.client = client;
                this.clientTempValues = JSON.parse(JSON.stringify(this.client));
                this.contactsDisplay = true;
                this.ticketsDisplay = true;
                this.timeplanDisplay = true;
                this.customerDisplay = true;
               if(this.$refs.fileUpload)
                this.$refs.fileUpload.removeFiles();

                if (this.fromClientAdmin) {
                    this.setActiveTab('tab3');
                    this.fromClientAdmin = false;
                }
               if (this.activeTab) {
                  const tab = 'tab' + this.activeTab;
                  this.setActiveTab(tab);
                  this.activeTab = 0;
               }
            },
            clientChanged: function(client) {
                var that = this;
                this.client = client;
                this.clientTempValues = JSON.parse(JSON.stringify(this.client));
                this.$refs.fileUpload.removeFiles();
                var fileLen = this.audioFiles.length;
                for(var i=0; i<fileLen; i++) {
                   var prop = this.audioFiles[i];
                   if(this.client[prop]) {
                      (function (j) {
                         setTimeout(function(){
                             var key = 'audioPreview' + j;
                             var audio = that.$refs['audioPreview' + j];
                             audio.src = audio.src + '?t=' + new Date().getTime();
                             audio.load();
                          }, 500);
                      })(i);
                   }
                }
            },
            soundsUpdated: function(){
                mainEventBus.$emit( 'alert', { type:'success', msg: 'msg_client_updated' } );
            },
            messageReceived: function(data){
                this.chatMessage = '';
                this.chatMessages.push(data)
            },
            contactUpdated(val) {
                console.log('HOME CONTACTUPDATED');
            },
        },
        mixins: [translationMixin, alertMixin, userMixin],
        created: function(){
            this.$socket.emit('getClientPerUser');
        },
        computed: {
            messageList: function(){
                return this.chatMessages;
            },
            rootPath: function(){
                return mainEventBus.$data.serverURL;
            },
            filePath: function(){
                var path = '';
                if(this.client.clientApiToken){
                    path = this.rootPath + '/api/twilio/' + this.client.clientApiToken + '/';
                }
                return path;
            },
           isTabActive: function(){
               return this.tabActive;
           }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.meta.isClientAdmin) {
                    vm.fromClientAdmin = true;
                }
               if(from.meta.activeTab){
                  vm.activeTab = from.meta.activeTab;
               }
            });
        },
        data: function() {
            return {
               tabActive: {
                  tab1: true,
                  tab2: false,
                  tab3: false,
                  tab4: false,
               },
                display: Boolean,
                client: {},
                clientPrevValues: {},
                show: false,
                chatMessages: [],
                chatMessage: '',
                contactsDisplay: false,
                ticketsDisplay: false,
                timeplanDisplay: false,
                showConfirmDelete: false,
                selectedFileType: '',
                audioStatus: [ false, false, false, false, false, false, false ],
                audioPlayingIndex: '',
                audioFiles: ['onDutyFile','offDutyFile','disturbFile','helpFile','acceptedFile','deniedFile','invalidFile','codeFile'],
                tempFiles: [],
                fromClientAdmin: false,
                activeTab: 0
            }
        },
        methods: {
           setActiveTab: function(tab){
              for (var i in this.tabActive){
                 this.tabActive[i] = false;
              }
              this.tabActive[tab] = true;
           },
            alertDanger: function(){
                mainEventBus.$emit( 'alert', { type:'error', msg:'Simple Error' } );
            },
            alertSuccess: function(){
                mainEventBus.$emit( 'alert', { type:'success', msg:'Simple Success' } );
            },
            lunchModalInfo: function(){
                this.show = true;
            },
            closeModalInfo: function(){
                this.show = false;
                this.showConfirmInfo = true;
                this.autoclose(this.hideAlert, 2000);
            },
            confirm: function(){
                this.answer = 'YES';
                this.showConfirm = false;
                this.show = true;
            },
            unconfirm: function(){
                this.answer = 'NO';
                this.showConfirm = false;
                this.show = true;
            },
            hideAlert: function(){
                this.showConfirmInfo = false;
            },
            setFiles: function(files) {
                if (this.tempFiles.find(file => file.fileField === '')) {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_select_file_type' } );
                    return false;
                }

                for (var i = 0; i < files.length; i++) {
                    if (files[i].fileObject.file) {
                        this.clientTempValues[files[i].value] = files[i].fileObject.name;
                        if (!this.clientTempValues.files)
                            this.clientTempValues.files = {};
                        this.clientTempValues.files[files[i].value] = files[i].fileObject.file;
                    }
                }
                this.$socket.emit('clientSoundsUpdate', this.clientTempValues);
            },
            setTempFiles(tempFiles) {
                this.tempFiles = tempFiles;
            },
            showConfirmDialog: function(fileType) {
                this.selectedFileType = fileType;
                this.showConfirmDelete = true;
            },
            confirmDelete: function(shouldDelete) {
                if (shouldDelete)
                    this.deleteFile(this.selectedFileType);

                this.selectedFileType = '';
                this.showConfirmDelete = false;
            },
            deleteFile: function(fileType) {
                var clientData = { _id: this.client._id };
                clientData[fileType] = this.client[fileType];

                this.$socket.emit('clientDeleteFile', clientData);
            },
            playRecord: function(index){
                var refKeys = Object.keys(this.$refs);
                var numIndex = parseInt(index.split('audioPreview')[1]);

                for (var i = 0; i < refKeys.length; i++) {
                    if (refKeys[i].indexOf('audioPreview') >= 0) {
                        if (refKeys[i] != index || this.isPlaying(index))
                            this.stopRecord(refKeys[i]);
                        else {
                            this.$refs[index].play();
                            this.audioStatus[numIndex] = true;
                        }
                    }
                }

                if (this.audioStatus[numIndex])
                    this.audioPlayingIndex = index;
            },
            stopRecord: function(index) {
               if(this.$refs[index]) {
                  this.$refs[index].pause();
                  this.$refs[index].currentTime = 0;
                  this.audioStatus[parseInt(index.split('audioPreview')[1])] = false;
                  this.audioPlayingIndex = '';
               }
            },
            isPlaying: function(index) {
                return !this.$refs[index].paused && this.$refs[index].currentTime > 0 && !this.$refs[index].ended;
            },
            audioPreviewClass: function(index) {
                if (this.audioPlayingIndex != index)
                    return 'fa-play';
                else
                    return 'fa-stop';
            },
            playStopTooltip: function(index) {
                if(this.audioPlayingIndex != index)
                    return 'lbl_play';
                else
                    return 'lbl_stop';
            }
        }
    }
</script>

<style scoped>
    .client-details-wrapper {
        border: 1px solid #ecf0f1;
        margin: 0 1px 15px;
        padding: 5px 0;
    }

    .el-icon-close {
        opacity: .75;
        transform: scale(.8);
        cursor: pointer;
        margin-left: 10px;
        color: #13ce66;
    }

    .el-icon-close:hover {
        color: #48576a;
    }
</style>


// WEBPACK FOOTER //
// Home.vue?f80d7ab2